export default __webpack_public_path__ + "images/8_2_image.jpg";